import { Button } from "@/components/ui/button";
import { ArrowRight, Zap, DollarSign, Users } from "lucide-react";

export const Hero = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-blue-50 to-emerald-50">
      <div className="absolute inset-0 bg-[url('/images/solar_school_1.jpeg')] bg-cover bg-center opacity-10"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Zap className="w-4 h-4" />
            Portfolio Zero PAC Partnership
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            Turn School Energy Upgrades into
            <span className="text-green-600 block">Student Funding</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-4xl mx-auto leading-relaxed">
            GreenSmart enables PACs to unlock <strong>full funding</strong> for student programs through 
            district-owned energy upgrades with <strong>zero up-front cost</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12 max-w-4xl mx-auto">
          <div className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg">
            <DollarSign className="w-8 h-8 text-green-600 mx-auto mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">$0 Up-Front Cost</h3>
            <p className="text-gray-600 text-sm">Complete energy upgrades with no initial investment required</p>
          </div>
          
          <div className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg">
            <Users className="w-8 h-8 text-blue-600 mx-auto mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">100% PAC Benefits</h3>
            <p className="text-gray-600 text-sm">All net financial benefits flow directly to PAC programs</p>
          </div>
          
          <div className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg">
            <Zap className="w-8 h-8 text-emerald-600 mx-auto mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">Fully Compliant</h3>
            <p className="text-gray-600 text-sm">Legal framework designed for PAC operational requirements</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size="lg" 
            className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 text-lg"
            onClick={() => scrollToSection('how-it-works')}
          >
            Learn How It Works
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          
          <Button 
            size="lg" 
            variant="outline" 
            className="border-green-600 text-green-600 hover:bg-green-50 px-8 py-4 text-lg"
            onClick={() => scrollToSection('calculator')}
          >
            Calculate Your Potential
          </Button>
        </div>
      </div>
    </section>
  );
};